import * as Sentry from '@sentry/react';

/**
 * Capture an exception and send it to Sentry
 * @param error - The error to capture
 * @param context - Additional context to include with the error
 */
export const captureException = (error: Error, context?: Record<string, any>) => {
  if (context) {
    Sentry.withScope(scope => {
      Object.entries(context).forEach(([key, value]) => {
        scope.setContext(key, value);
      });
      Sentry.captureException(error);
    });
  } else {
    Sentry.captureException(error);
  }
};

/**
 * Capture a message and send it to Sentry
 * @param message - The message to capture
 * @param level - The severity level
 * @param context - Additional context to include with the message
 */
export const captureMessage = (
  message: string,
  level: Sentry.SeverityLevel = 'info',
  context?: Record<string, any>,
) => {
  if (context) {
    Sentry.withScope(scope => {
      Object.entries(context).forEach(([key, value]) => {
        scope.setContext(key, value);
      });
      Sentry.captureMessage(message, level);
    });
  } else {
    Sentry.captureMessage(message, level);
  }
};

/**
 * Add breadcrumb for debugging
 * @param message - The breadcrumb message
 * @param category - The category of the breadcrumb
 * @param level - The severity level
 * @param data - Additional data
 */
export const addBreadcrumb = (
  message: string,
  category: string = 'custom',
  level: Sentry.SeverityLevel = 'info',
  data?: Record<string, any>,
) => {
  Sentry.addBreadcrumb({
    message,
    category,
    level,
    data,
  });
};
